import script from "./toggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./toggle.vue?vue&type=script&lang=ts&setup=true"

import "./toggle.vue?vue&type=style&index=0&id=0c340b78&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c340b78"]])

export default __exports__